import {
    getNextItemsScopeItemKey,
    createItemCacheStore,
    IItemCacheStore,
    IItemsScopeInitializerPayload,
    IItemCacheDispatch,
    switchLayout,
    tilesLayoutType,
    openItem,
    Facet,
    readItems,
    IItemCache,
    resolveItems,
} from '@ms/items-view';
import { filesAddon } from './filesAddon';
import { mailboxFileSetKeyFacet } from '../Schema/Facets';
import { getFilterStore } from './FilterStore';
import { getParameterStore } from './ParametersStore';

export { IItemCacheStore };

export const itemCacheStore: IItemCacheStore = createItemCacheStore({});

interface ItemScopeKeyCacheItem {
    itemsScopeItemKey: string;
}

const itemKey: ItemScopeKeyCacheItem = {
    itemsScopeItemKey: getNextItemsScopeItemKey(),
};

const seenItemFacet = new Facet<boolean>('hasSeenItem');

export const updateItemsViewCache = () => {
    const dateString = getFilterStore().dateRangeFilter.selectedValue.dateRange
        ? getFilterStore().dateRangeFilter.selectedValue.dateRange.endDate.toString() +
          getFilterStore().dateRangeFilter.selectedValue.dateRange.startDate.toString()
        : '';

    const extensionString = getFilterStore().extensionGroupFilter.selectedValue.size
        ? getFilterStore().extensionGroupFilter.selectedValue.toString()
        : '';

    const filterStateString = extensionString + dateString;

    const initializer = (payload: IItemsScopeInitializerPayload) => {
        return (dispatch: IItemCacheDispatch) => {
            dispatch(filesAddon);

            const hasSeenItem = dispatch(
                readItems((itemCache: IItemCache) =>
                    itemCache.demandItemFacet(seenItemFacet, itemKey.itemsScopeItemKey)
                )
            );

            if (!hasSeenItem) {
                dispatch(
                    switchLayout({
                        ...payload,
                        layoutType: tilesLayoutType,
                    })
                );
            }

            dispatch(
                resolveItems({ items: { [itemKey.itemsScopeItemKey]: seenItemFacet.pack(true) } })
            );

            dispatch(
                openItem({
                    ...payload,
                    currentItemKey: mailboxFileSetKeyFacet.serialize({
                        mailboxKey: { smtp: getParameterStore().mailboxInfo.mailboxId },
                        filterState: filterStateString,
                    }),
                })
            );
        };
    };

    itemCacheStore.dispatch(
        initializer({
            itemsScopeItemKey: itemKey.itemsScopeItemKey,
        })
    );
};

export const getItemScopeItemKey = (): string => {
    return itemKey.itemsScopeItemKey;
};
